'use memo';

import { AutopilotTaskDto } from '@urbanx/agx.activities.client';
import { CampaignDetailModel } from '@urbanx/agx.campaigns.client';
import TaskModalDialog from './TaskModalDialog';
import { useAgreementComplianceModal } from './useAgreementComplianceModal';

interface AgreementComplianceModalProps {
  campaignId: string;
  campaign: CampaignDetailModel;
  isOpen: boolean;
  onClose: () => void;
  onCompleteSuccess?: () => void;
  tasks: AutopilotTaskDto[];
}

const AgreementComplianceModal = ({
  campaignId,
  campaign,
  isOpen,
  onClose,
  onCompleteSuccess,
  tasks,
}: AgreementComplianceModalProps) => {
  const { contentConfig } = useAgreementComplianceModal({
    campaignId,
    campaign,
    isOpen,
    tasks,
  });

  if (!isOpen) return null;

  return (
    <TaskModalDialog
      title={'Agreement Compliance'}
      tasks={tasks}
      open={isOpen}
      onClose={onClose}
      campaignId={campaignId}
      campaign={campaign}
      contentConfig={{
        ...contentConfig,
        onCompleteSuccess,
        hideTaskMetadata: true,
        hideCloseButton: true,
        previousButtonText: 'Previous',
        presentationClassName: 'taskModal--agreementCompliance',
      }}
    />
  );
};

export default AgreementComplianceModal;
